import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';

import { PARTNER_USER_ACTION } from '../../models';
import { PARTNER_USER_ACTIONS, PartnerUserActionConfig } from './partner-user-actions.config';

@Component({
  selector: 'rms-partner-user-actions',
  imports: [MatIconButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger, MatProgressSpinner, TranslatePipe],
  templateUrl: './partner-user-actions.component.html',
})
export class PartnerUserActionsComponent {
  @Input() public actions: PartnerUserActionConfig[] = PARTNER_USER_ACTIONS;
  @Input() public loading = false;
  @Output() public selected = new EventEmitter<PARTNER_USER_ACTION>();
}
